/**
 * @generated SignedSource<<004b61e60a924ea98b80763cd23873e0>>
 * @relayHash 5ca9178b3c5939ba3a0bfc87c2be9628
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 94dac497c9a63d2169f11b32468c2ce4966c86561ef7adb50b55d285473eb67f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FirstCreateViewQuery } from './FirstCreateViewQuery.graphql';

const node: PreloadableConcreteRequest<FirstCreateViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "94dac497c9a63d2169f11b32468c2ce4966c86561ef7adb50b55d285473eb67f",
    "metadata": {},
    "name": "FirstCreateViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
